import React, { useCallback, useState } from 'react'

interface Props {
    to: number
    onSeek(e: React.MouseEvent, seek?: boolean): Promise<number | undefined>
    trackDivide?: number
}

export const Seeker: React.FC<Props> = ({ to, onSeek, trackDivide = 1 }) => {
    
    const [tempLeft, setTempLeft] = useState<number | undefined>(undefined)
    
    const getSeekPosition = useCallback((to: number) => ({ left: to + '%' }), [])

    const onDrag = async (e: React.DragEvent<HTMLDivElement>) => {
        const to = await onSeek(e, false)
        setTempLeft(to)
    }

    const onDragEnd = (e: React.DragEvent<HTMLDivElement>) => {
        onSeek(e)
        setTempLeft(undefined)
    }

    const allStyles = {
        ...getSeekPosition(tempLeft ?? to),
        '--trackDiv': trackDivide
    }

    return (
        <div data-testid="seeker" onDrag={onDrag} onDragEnd={onDragEnd} className="seeker-wrapper">
            <div draggable="true" style={allStyles} className="seeker" />
        </div>
    )
}
